import { useIsCopilotEnabled } from '@common/Copilot/useIsCopilotEnabled';
import { Dialog, Text } from '@prophecy/ui-v3';
import { afterAnimationFrame } from '@prophecy/utils/dom';
import { useEffect } from 'react';

import { useGlobalVariables } from '../../context/globalConfig/securedConfigHook';
import { useUser } from '../../context/user';
import { SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED } from '../../utils/localstorage-keys';

export function JPMCPostLoginCopilotPopup() {
  const { user } = useUser();
  const { showJpmcPostLoginCopilotPopup } = useGlobalVariables();
  const isCopilotEnabled = useIsCopilotEnabled();

  useEffect(() => {
    if (!user?.id || !isCopilotEnabled || !showJpmcPostLoginCopilotPopup) {
      return;
    }

    const shouldShowPopup = localStorage.getItem(SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED) !== 'true';
    if (!shouldShowPopup) {
      return;
    }

    afterAnimationFrame(() => {
      Dialog.info({
        title: 'Prophecy Copilot usage and Output Validation',
        size: 'l',
        children: (
          <Text level='sm'>
            <br />
            Prophecy Copilot enables users to convert natural language queries into data pipeline code (Spark or SQL). A
            human in the loop should review the generated code and other AI-generated output from this tool, as the
            output might be incorrect or incomplete. Users should understand Spark or SQL to validate both the generated
            code and any other output, such as pipeline summaries or descriptions. Do not use Payment Card Industry
            (PCI) data within this tool.
            <br />
            <br />
            Prophecy Copilot is powered by the InfiniteAI platform. Please review the firm's{' '}
            <a
              href='https://confluence.prod.aws.jpmchase.net/confluence/spaces/MLCOELLM/pages/4326647665/Guidelines+for+Using+AI+LLM+Tools'
              target='_blank'
              rel='noopener noreferrer'>
              Guidelines for Using AI/LLM
            </a>
            .
            <br />
            <br />
          </Text>
        ),
        okButton: {
          children: 'Acknowledge'
        },
        onOk: () => {
          localStorage.setItem(SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED, 'true');
        },
        closeButton: null,
        closable: false,
        showCloseIcon: false,
        'data-test-id': 'post-login-popup'
      });
    });
  }, [user?.id, isCopilotEnabled, showJpmcPostLoginCopilotPopup]);

  return null;
}
